<template>
    <div class="wx-login" id="wx_login">
    </div>
</template>

<script>
/* eslint-disable */
  export default {
    name: "akwxlogin",
    created () {
      if(this.$utils.getCookie('logined') === 'yes'){
        // $("#go_self").show();
        // $("#mail_box").hide();
      }
      else{
        var frm = new WxLogin({
          self_redirect:true,
          id:"wx_login",
          appid: "wxa6d13691bd087320",
          scope: "snsapi_login",
          redirect_uri: "https://www.anyknew.com/bespoke",
          state: "bespoke",
          style: "black",
          href: ""
        });
      }
    }
  }

</script>

<style>

</style>